var map = {
	"./buttons.png": 122,
	"./buttons@2x.png": 124
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 185;



//////////////////
// WEBPACK FOOTER
// ./sprite ^\.\/buttons.*\.png$
// module id = 185
// module chunks = 3